/**
 * Tests if an element has overflown its contents
 *
 * https://stackoverflow.com/a/9541579
 **/
export const testHasOverflown = (element: HTMLElement) => {
  return element.scrollWidth > element.offsetWidth;
};
